import DelegateName from './DelegateName';
import FromDate from './FromDate';
import ToDate from './ToDate';
import DelegateTitle from './DelegateTitle';
import BusinessJustification from './BusinessJustification';

const Forms = {
    DelegateTitle,
    DelegateName,
    FromDate,
    ToDate,
    BusinessJustification,
};

export default Forms;
